import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { urlConst } from '../consts';
import { apiService } from './api.service';
import { delay } from '../util/delay';

let fpAgent;
FingerprintJS.load()
    .then(agent => {
        fpAgent = agent;
    })
    .catch(console.error);

export const clientVoicesService = {
    getVoices,
    setVoice,
    createToken
};

async function getVoices() {
    while (!fpAgent) {
        // eslint-disable-next-line no-await-in-loop
        await delay(200);
    }
    const visitor = await fpAgent.get();

    return apiService.get(`${urlConst.API_GET_CLIENT_VOICES}?client=${visitor.visitorId}`);
}

async function setVoice(requestId, liked) {
    while (!fpAgent) {
        // eslint-disable-next-line no-await-in-loop
        await delay(200);
    }
    const visitor = await fpAgent.get();
    return apiService.post(
        urlConst.API_SET_CLIENT_VOICE,
        JSON.stringify({
            client: visitor.visitorId,
            voices: { [requestId]: liked }
        })
    );
}

async function createToken(x, y) {
    while (!fpAgent) {
        // eslint-disable-next-line no-await-in-loop
        await delay(200);
    }
    const visitor = await fpAgent.get();
    return apiService.get(`${urlConst.API_APPROVE_CLIENT}?client=${visitor.visitorId}&x=${x}&y=${y}`);
}
